let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("j1t8s")).then(() => parcelRequire('1Fh1n'));